var map = {
	"./close.png": "a06f",
	"./dingxiligong_login.jpg": "2710",
	"./loginBG.jpg": "04c0",
	"./loginIcon01.png": "e515",
	"./loginIcon02.png": "5aeb",
	"./loginLeftBG.png": "b971",
	"./login_bg.jpg": "61a3",
	"./login_left_img.png": "3b5c",
	"./logo_lx.png": "25bd",
	"./product12_login.jpg": "c06c",
	"./weChart.png": "36d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4eec";